import { css } from 'styled-components';

export default {
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '1074px',
    lg: '1400px',
    xl: '1920px'
  },
  font: {
    brand: {
      xl: css`
        font-weight: bold;
        font-size: 72px;
        line-height: 72px;
      `,
      lg: css`
        font-weight: bold;
        font-size: 54px;
        line-height: 54px;
      `,
      md: css`
        font-weight: bold;
        font-size: 40px;
        line-height: 40px;
      `,
      sm: css`
        font-weight: bold;
        font-size: 28px;
        line-height: 28px;
      `
    },
    header: {
      xxl: css`
        font-weight: bold;
        font-size: 40px;
        line-height: 44px;
      `,
      xl: css`
        font-weight: bold;
        font-size: 28px;
        line-height: 32px;
      `,
      m: css`
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
      `,
      s: css`
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
      `,
      xs: css`
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
      `
    },
    label: {
      l: css`
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
      `,
      m: css`
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
      `,
      s: css`
        font-weight: bold;
        font-size: 12px;
        line-height: 16px;
      `,
      xs: css`
        font-weight: bold;
        font-size: 10px;
        line-height: 12px;
      `
    },
    body: {
      l: css`
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
      `,
      m: css`
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
      `,
      s: css`
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
      `,
      xs: css`
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
      `
    },
    link: {
      m: css`
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
      `,
      s: css`
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
      `
    }
  }
};
